var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("translates", {
    attrs: {
      item: this.group,
      item_id: parseInt(_vm.group.id),
      item_type: "group",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }